/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Flex,
  Grid,
  Option,
  Select,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobalApi, ProvisionApi } from '@Apis';
import { PolicyType } from '../../../types/app';

import { PaymentModel } from '../../../types/provision';

import { GrantedAccess } from '../Common/GrantedAccess';
import ErrorAlert from '../../../components/Common/ErrorAlert';
import { useOrgStore } from '../../../models/useOrgModel';
import CSpinner from '../../../components/CSpinner';
import {
  SaModalNameEnum,
  SaModalState,
} from '../../Administrator/ServiceAccount/types';
import TeamsChatModal from './TeamsChatModal';
import { usePermissionStore } from '@Models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
const MicrosoftLicensingModelSettingsForTeamsChat = () => {
  const { widthEditablePermission } = usePermissionStore();
  const withEditPermission = widthEditablePermission(
    PermissionNameEnum.administrator
  );
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useTranslation();
  const { orgId } = useOrgStore();
  const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined);
  const [selectModel, setSelectModel] = useState('Evaluation');
  const [selectedPolicyType, setSelectedPolicyType] =
    React.useState<string>('');
  const [isShowMultiService, setIsShowMultiService] =
    React.useState<boolean>(false);
  const [appId, setAppId] = useState<string>('');
  async function loadData() {
    try {
      setLoading(true);
      const data: any = (await GlobalApi.getTeamsChatModelList()).data;
      const policyTypes = (
        await ProvisionApi.getProvisionedServicesByOrgId(orgId)
      ).data;

      const result = policyTypes.filter((item) =>
        [PolicyType.TeamsChat].includes(item)
      );
      if (result.length === 0) {
        setIsShowMultiService(false);
        setSelectedPolicyType(PolicyType.TeamsChat.toString());
      } else {
        setIsShowMultiService(true);
        const appId = (await GlobalApi.getTeamsChatAppId()).data;
        setAppId(appId.appId);
        setSelectModel(data.data.licensingModel);
      }
    } catch (error: any) {
      setErrorMsg(t('common.apiException.internalError'));
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    (async function doCall() {
      await loadData();
    })();
  }, [orgId]);

  const handleChangeValue = (e: any) => {
    setSelectModel(e.target.value);
  };
  const onSave = async () => {
    const res =
      await GlobalApi.updateTeamsChatLicensingModelSettings(selectModel);
    if (res.data) {
      window.showNotification({
        titleMsg: t('globalSetting.switch.success'),
        severity: 'success',
      });
    } else {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    }
  };

  const [saModalState, setSaModalState] = useState<SaModalState>(null);
  const refreshData = () => {
    //init state
    setSaModalState(null);
  };
  return (
    <Box px="4x">
      {loading && <CSpinner />}
      {isShowMultiService && !loading ? (
        <Box>
          {errorMsg && (
            <ErrorAlert
              errorMsg={errorMsg}
              onClose={() => setErrorMsg(undefined)}
            />
          )}
          <Flex m="16px 0px">
            <Text
              fontSize="lg"
              lineHeight="lg"
              color={colorStyle.color.primary}
            >
              {t(
                'globalSetting.microsoftLicensingModelSettingsForTeamsChat.tab.title'
              )}
            </Text>
          </Flex>
          <Flex m="16px 0px">
            <Grid
              columnGap="3x"
              rowGap="3x"
              templateColumns="60px 1.5fr 5rem"
              gap="3x"
              mt="0px"
            >
              <Grid>
                <Space width={60} display="inline-flex" alignItems="center">
                  {t(
                    'globalSetting.microsoftLicensingModelSettingsForTeamsChat.appId.title'
                  )}
                  :
                </Space>
              </Grid>
              <Grid>
                <Space display="inline-flex" alignItems="center">
                  {appId}
                </Space>
              </Grid>
              <Grid>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setSaModalState({
                      name: SaModalNameEnum.UpdateSecretOrChangeApp,
                      data: {
                        orgId,
                        appId,
                      },
                    });
                  }}
                  disabled={!withEditPermission}
                >
                  {t(
                    'globalSetting.microsoftLicensingModelSettingsForTeamsChat.appId.button'
                  )}
                </Button>
              </Grid>
            </Grid>
          </Flex>
          <Flex m="16px 0px">
            <Text>
              <Space>
                {t(
                  'globalSetting.microsoftLicensingModelSettingsForTeamsChat.selectModel.title'
                )}
                :
              </Space>
              <Space width="3x"></Space>
              <Space color={colorStyle.color.secondary}>
                <Select
                  value={selectModel}
                  onChange={handleChangeValue}
                  disabled={!withEditPermission}
                >
                  {[
                    PaymentModel.ModelA,
                    PaymentModel.ModelB,
                    PaymentModel.Evaluation,
                  ].map((model) => (
                    <Option key={model} value={model}>
                      {t(
                        `globalSetting.microsoftLicensingModelSettingsForTeamsChat.selectModel.title.${model}`
                      )}
                    </Option>
                  ))}
                </Select>
              </Space>
            </Text>
          </Flex>
          <Flex m="16px 0px">
            <Text>
              {t(
                `globalSetting.microsoftLicensingModelSettingsForTeamsChat.selectModel.node.${selectModel}`
              )}
            </Text>
          </Flex>
          <Flex
            position="fixed"
            pl="5x"
            bottom={0}
            background={colorStyle.background.secondary}
            height={64}
            width="100%"
            align="center"
            justify="flex-start"
          >
            <Button
              variant="primary"
              onClick={onSave}
              disabled={!withEditPermission}
            >
              {t('common.action.label.save')}
            </Button>
          </Flex>
          <TeamsChatModal
            saModalState={saModalState}
            onClose={() => {
              setSaModalState(null);
            }}
            refreshData={refreshData}
          />
        </Box>
      ) : null}
      {!isShowMultiService && !loading ? (
        <GrantedAccess
          selectedPolicyType={selectedPolicyType}
          orgId={orgId}
        ></GrantedAccess>
      ) : null}
    </Box>
  );
};
export default MicrosoftLicensingModelSettingsForTeamsChat;
